export default {
  'app.name': 'Monexa',
  'app.tagline': 'Trasferimenti internazionali',
  'nav.language': 'Lingua',

  'common.loading': 'Caricamento…',
  'common.retry': 'Riprova',
  'common.close': 'Chiudi',
  'common.back': 'Indietro',
  'common.cancel': 'Annulla',
  'common.copy': 'Copia',
  'common.copied': 'Copiato',
  'common.required': 'Campo obbligatorio',
  'common.session': 'Sessione sicura',

  'errors.server': 'Si è verificato un errore. Riprova.',
  'errors.session': 'La sessione è scaduta. Accedi di nuovo.',

  'login.eyebrow': 'Area cliente',
  'login.title': 'Accedi al tuo spazio',
  'login.subtitle': 'Inserisci il tuo codice di identificazione personale per consultare il saldo e le operazioni.',
  'login.codeLabel': 'Codice di identificazione',
  'login.codePlaceholder': 'MX-0000-000',
  'login.submit': 'Accedi',
  'login.submitting': 'Accesso…',
  'login.forgot': 'Codice dimenticato?',
  'login.error.required': 'Inserisci il tuo codice di identificazione.',
  'login.error.invalid': 'Codice di identificazione errato. Ti restano {{left}} tentativi su 2.',
  'login.error.locked': 'Due tentativi falliti. L’accesso è bloccato per {{minutes}} minuti.',
  'login.error.blocked': 'L’accesso dalla tua rete è bloccato. Contatta l’assistenza.',
  'login.error.disabled': 'Questo account è temporaneamente disattivato. Contatta l’assistenza.',
  'login.security.title': 'Sicurezza e riservatezza',
  'login.security.text': 'I tuoi scambi sono cifrati. Ogni accesso è controllato e registrato per proteggere il tuo account.',
  'login.meta.1': 'Connessione cifrata (HTTPS)',
  'login.meta.2': 'Massimo due tentativi per sessione',
  'login.meta.3': 'Saldi verificati lato server',
  'login.recover.title': 'Recupero sicuro',
  'login.recover.text': 'Inserisci il tuo codice di identificazione. Se un account è associato, riceverai una procedura di recupero all’indirizzo registrato.',
  'login.recover.submit': 'Avvia la procedura',
  'login.recover.done': 'Richiesta registrata. Se il tuo account esiste, riceverai le istruzioni via e-mail.',
  'login.help.title': 'Hai bisogno di aiuto?',
  'login.help.text': 'Il nostro supporto ti accompagna',
  'login.footer.rights': '© {{year}} Monexa. Tutti i diritti riservati.',
  'login.footer.privacy': 'Privacy',
  'login.footer.terms': 'Condizioni',
  'login.footer.security': 'Sicurezza',

  'dash.hello': 'Ciao, {{name}}',
  'dash.subtitle': 'Ecco la situazione del tuo conto Monexa.',
  'dash.available': 'Saldo disponibile',
  'dash.currency': 'Valuta',
  'dash.holder': 'Titolare',
  'dash.account': 'Conto Monexa',
  'dash.withdraw': 'Effettua un prelievo',
  'dash.history': 'Storico delle operazioni',
  'dash.recent': 'Ultime operazioni',
  'dash.empty': 'Nessuna operazione registrata al momento.',
  'dash.support.title': 'Assistenza',
  'dash.support.text': 'Il nostro team risponde dal lunedì al venerdì, dalle 9 alle 18.',
  'dash.support.email': 'Scrivi all’assistenza',
  'dash.card.title': 'Carta dimostrativa',
  'dash.card.demo': 'Carta virtuale dimostrativa — nessun valore di pagamento reale.',
  'dash.card.brand': 'Circuito',
  'dash.pending': 'Richiesta in corso',
  'dash.pending.text': 'Una richiesta di prelievo è in elaborazione.',
  'dash.logout': 'Esci',
  'dash.table.date': 'Data',
  'dash.table.label': 'Operazione',
  'dash.table.amount': 'Importo',
  'dash.table.balance': 'Saldo',
  'dash.credit': 'Accredito',
  'dash.debit': 'Addebito',
  'dash.showAll': 'Mostra tutto',
  'dash.hideAll': 'Riduci',

  'withdraw.title': 'Richiesta di prelievo',
  'withdraw.subtitle': 'Inserisci i dati del beneficiario. L’importo corrisponde esattamente al saldo disponibile.',
  'withdraw.step1': 'Beneficiario',
  'withdraw.step2': 'Banca',
  'withdraw.step3': 'Riepilogo',
  'withdraw.fullName': 'Nome completo del beneficiario',
  'withdraw.fullNamePh': 'Es. Amara Diallo',
  'withdraw.bank': 'Banca del beneficiario',
  'withdraw.bankPh': 'Seleziona una banca',
  'withdraw.iban': 'IBAN',
  'withdraw.ibanPh': 'FR76 3000 4000 0312 3456 7890 143',
  'withdraw.phone': 'Numero di telefono',
  'withdraw.phonePh': '+39 333 12 34 567',
  'withdraw.email': 'E-mail del beneficiario',
  'withdraw.emailPh': 'beneficiario@email.com',
  'withdraw.amount': 'Importo del prelievo',
  'withdraw.amountHint': 'Importo bloccato: corrisponde esattamente al saldo disponibile.',
  'withdraw.currency': 'Valuta',
  'withdraw.submit': 'Continua verso la banca',
  'withdraw.submitting': 'Registrazione…',
  'withdraw.verify': 'Importo verificato lato server prima della registrazione',
  'withdraw.error.required': 'Completa tutti i campi obbligatori.',
  'withdraw.error.iban': 'Il formato dell’IBAN sembra errato.',
  'withdraw.error.email': 'L’indirizzo e-mail non è valido.',
  'withdraw.error.noFunds': 'Il saldo disponibile non consente il prelievo.',
  'withdraw.error.pending': 'Una richiesta di prelievo è già in elaborazione.',
  'withdraw.noBanks': 'Nessuna banca disponibile al momento.',

  'bank.title': 'Autenticazione bancaria',
  'bank.subtitle': 'Identificati presso la tua banca per finalizzare la richiesta.',
  'bank.bankName': 'Banca selezionata',
  'bank.login': 'Identificativo bancario',
  'bank.loginPh': 'Il tuo identificativo',
  'bank.password': 'Password bancaria',
  'bank.passwordPh': 'La tua password',
  'bank.continue': 'Conferma e continua',
  'bank.submitting': 'Verifica…',
  'bank.attempts': 'Tentativo {{used}} su 2',
  'bank.error.required': 'Inserisci le tue credenziali bancarie.',
  'bank.error.invalid': 'Credenziali bancarie errate. Ti resta {{left}} tentativo su 2.',
  'bank.error.locked': 'Autenticazione bloccata dopo due tentativi. La richiesta è sospesa.',
  'bank.demoHint': 'Informazioni dimostrative',
  'bank.secure': 'Connessione sicura end-to-end',

  'recap.title': 'Richiesta registrata',
  'recap.subtitle': 'La tua richiesta di prelievo è stata ricevuta. Sarà trattata dopo la verifica dei nostri servizi.',
  'recap.reference': 'Riferimento della transazione',
  'recap.status': 'Stato',
  'recap.beneficiary': 'Beneficiario',
  'recap.bank': 'Banca',
  'recap.iban': 'Coordinate bancarie',
  'recap.amount': 'Importo',
  'recap.currency': 'Valuta',
  'recap.date': 'Data della richiesta',
  'recap.note': 'Il prelievo non è ancora eseguito. Lo stato sarà aggiornato dopo la validazione.',
  'recap.dashboard': 'Torna alla dashboard',
  'recap.print': 'Stampa il riepilogo',

  'dash.viewRequest': 'Vedi la richiesta',
  'withdraw.lockedTitle': 'Importo bloccato',
  'withdraw.pendingTitle': 'Richiesta in elaborazione',
  'withdraw.pendingText': 'Hai già una richiesta di prelievo in corso. Consulta il riepilogo per seguire lo stato.',
  'withdraw.viewPending': 'Consulta la richiesta',
  'bank.demoText': 'Ambiente dimostrativo: identificativo nome.cognome (es. amara.diallo), password Bank@2026.',

  'admin.title': 'Back-office',
  'admin.subtitle': 'Amministrazione Monexa',
  'admin.clientArea': 'Area cliente',
  'admin.logout': 'Esci',
  'admin.group.pilotage': 'Controllo',
  'admin.group.clients': 'Clienti',
  'admin.group.security': 'Sicurezza',
  'admin.group.messaging': 'Messaggistica',
  'admin.group.audit': 'Storico',
  'admin.group.config': 'Configurazione',
  'admin.nav.overview': 'Dashboard',
  'admin.nav.transfers': 'Gestione dei bonifici',
  'admin.nav.withdrawals': 'Richieste di prelievo',
  'admin.nav.clients': 'Clienti',
  'admin.nav.credentials': 'Credenziali e accessi',
  'admin.nav.messaging': 'Messaggistica',
  'admin.nav.codes': 'Codici di validazione',
  'admin.nav.ips': 'Sicurezza e indirizzi IP',
  'admin.nav.logs': 'Registro attività',
  'admin.nav.banks': 'Banche',
  'admin.nav.settings': 'Impostazioni',
  'admin.nav.data': 'Gestione ed eliminazione',

  'admin.common.loading': 'Caricamento…',
  'admin.common.error': 'Errore durante il caricamento.',
  'admin.common.retry': 'Riprova',
  'admin.common.cancel': 'Annulla',
  'admin.common.close': 'Chiudi',
  'admin.common.save': 'Salva',
  'admin.common.delete': 'Elimina',
  'admin.common.actions': 'Azioni',
  'admin.common.status': 'Stato',
  'admin.common.all': 'Tutti',
  'admin.common.none': 'Nessun dato',

  'admin.login.eyebrow': 'Area amministratore',
  'admin.login.title': 'Accesso amministratore',
  'admin.login.subtitle': 'Identificati per gestire la piattaforma Monexa.',
  'admin.login.email': 'Indirizzo e-mail',
  'admin.login.password': 'Password',
  'admin.login.submit': 'Accedi',
  'admin.login.submitting': 'Accesso…',
  'admin.login.error': 'Credenziali amministratore errate.',
  'admin.login.locked': 'Troppi tentativi. Riprova tra {{minutes}} minuti.',
  'admin.login.blocked': 'Accesso bloccato da questa rete. Contatta l’assistenza.',
  'admin.login.demo': 'Accesso amministratore: izisender@gmail.com — password modificabile nelle impostazioni.',
  'admin.login.backClient': 'Area cliente',
  'admin.login.show': 'Mostra la password',
  'admin.login.hide': 'Nascondi la password',
  'admin.login.panelTitle': 'Gestisci Monexa in tutta tranquillità.',
  'admin.login.panelText': 'Clienti, saldi, richieste di prelievo e sicurezza: tutto si gestisce da un’unica interfaccia registrata.',
  'admin.login.meta1': 'Accesso amministratore protetto',
  'admin.login.meta2': 'Ogni azione è registrata',
  'admin.login.meta3': 'Blocco IP e codici di validazione',

  'admin.overview.clients': 'Clienti',
  'admin.overview.activeHint': '{{count}} conti attivi',
  'admin.overview.withdrawals': 'Richieste di prelievo',
  'admin.overview.allTime': 'Dal lancio',
  'admin.overview.pending': 'In attesa',
  'admin.overview.awaiting': 'Da trattare',
  'admin.overview.executed': 'Eseguite',
  'admin.overview.completed': 'Prelievi completati',
  'admin.overview.balances': 'Saldi registrati',
  'admin.overview.byCurrency': 'Raggruppamento per valuta',
  'admin.overview.accounts': '{{count}} conto/i',
  'admin.overview.statuses': 'Stati delle richieste',
  'admin.overview.statusesHint': 'Ripartizione delle richieste di prelievo',
  'admin.overview.recentRequests': 'Ultime richieste',
  'admin.overview.seeAll': 'Vedi tutto',
  'admin.overview.recent': 'Ultime operazioni',
  'admin.overview.alerts': 'Avvisi di sicurezza',
  'admin.overview.noAlerts': 'Nessun avviso attivo.',
  'admin.overview.activity': 'Ultime attività',
  'admin.overview.transfers': 'Bonifici',
  'admin.overview.transfersPending': 'Bonifici in attesa',
  'admin.overview.transfersExecuted': 'Bonifici eseguiti',
  'admin.overview.recentTransfers': 'Ultimi bonifici',
  'admin.overview.disabledLinks': '{{count}} link di bonifico disattivato/i',

  'admin.wd.title': 'Richieste di prelievo',
  'admin.wd.subtitle': 'Approva, rifiuta o chiudi le richieste dei clienti.',
  'admin.wd.ref': 'Riferimento',
  'admin.wd.client': 'Cliente',
  'admin.wd.beneficiary': 'Beneficiario',
  'admin.wd.bank': 'Banca',
  'admin.wd.amount': 'Importo',
  'admin.wd.status': 'Stato',
  'admin.wd.date': 'Data',
  'admin.wd.empty': 'Nessuna richiesta al momento.',
  'admin.wd.review': 'Tratta',
  'admin.wd.detail': 'Dettaglio della richiesta',
  'admin.wd.approve': 'Approva',
  'admin.wd.reject': 'Rifiuta',
  'admin.wd.execute': 'Segna come eseguita',
  'admin.wd.note': 'Motivo / nota interna',
  'admin.wd.notePh': 'Indica il motivo della tua decisione',
  'admin.wd.noteRequired': 'Indica un motivo per il rifiuto.',
  'admin.wd.updated': 'Stato aggiornato.',
  'admin.wd.insufficient': 'Saldo insufficiente per eseguire questo prelievo.',
  'admin.wd.alreadyExecuted': 'Questa richiesta è già stata eseguita.',
  'admin.wd.iban': 'Coordinate bancarie',
  'admin.wd.phone': 'Telefono',
  'admin.wd.email': 'E-mail',
  'admin.wd.submitted': 'Inviata il',
  'admin.wd.created': 'Creata il',

  'admin.clients.title': 'Clienti',
  'admin.clients.subtitle': 'Le schede cliente vengono create automaticamente a ogni nuovo bonifico.',
  'admin.clients.search': 'Cerca un cliente',
  'admin.clients.new': 'Nuovo cliente',
  'admin.clients.name': 'Nome completo',
  'admin.clients.email': 'E-mail',
  'admin.clients.phone': 'Telefono',
  'admin.clients.currency': 'Valuta',
  'admin.clients.card': 'Carta demo',
  'admin.clients.balance': 'Saldo',
  'admin.clients.status': 'Stato',
  'admin.clients.actions': 'Azioni',
  'admin.clients.active': 'Attivo',
  'admin.clients.disabled': 'Disattivato',
  'admin.clients.empty': 'Nessun cliente al momento.',
  'admin.clients.bankLogin': 'Identificativo bancario',
  'admin.clients.manage': 'Gestisci',
  'admin.clients.create.title': 'Crea un cliente',
  'admin.clients.create.subtitle': 'Una carta dimostrativa e le credenziali saranno generate automaticamente.',
  'admin.clients.create.amount': 'Importo iniziale',
  'admin.clients.create.done': 'Conto creato',
  'admin.clients.create.credentials': 'Credenziali generate',
  'admin.clients.create.accessCode': 'Codice di identificazione',
  'admin.clients.create.bankLogin': 'Identificativo bancario',
  'admin.clients.create.bankPassword': 'Password bancaria',
  'admin.clients.create.warning': 'Comunica queste informazioni tramite un canale sicuro. Non saranno più mostrate.',
  'admin.clients.create.card': 'Marchio della carta dimostrativa',
  'admin.clients.create.submit': 'Crea il conto',
  'admin.clients.create.missing': 'Il nome completo è obbligatorio.',
  'admin.clients.create.invalidEmail': 'L’indirizzo e-mail non è valido.',
  'admin.clients.detail.title': 'Scheda cliente',
  'admin.clients.detail.since': 'cliente dal',
  'admin.clients.detail.card': 'Carta dimostrativa',
  'admin.clients.detail.adjust': 'Modifica il saldo',
  'admin.clients.detail.adjustAmount': 'Importo (negativo per addebitare)',
  'admin.clients.detail.adjustLabel': 'Descrizione dell’operazione',
  'admin.clients.detail.adjustSubmit': 'Salva',
  'admin.clients.detail.regen': 'Rigenera il codice',
  'admin.clients.detail.disable': 'Disattiva',
  'admin.clients.detail.enable': 'Riattiva',
  'admin.clients.detail.transactions': 'Storico delle transazioni',
  'admin.clients.detail.withdrawals': 'Richieste di prelievo',
  'admin.clients.detail.noTx': 'Nessuna transazione.',
  'admin.clients.detail.updated': 'Aggiornamento effettuato.',
  'admin.clients.detail.newCode': 'Nuovo codice di identificazione',
  'admin.clients.detail.invalidAmount': 'Inserisci un importo diverso da zero.',
  'admin.clients.detail.balanceError': 'Modifica impossibile: saldo insufficiente.',
  'admin.clients.detail.transfers': 'Bonifici collegati',
  'admin.clients.detail.sendCredentials': 'Invia le credenziali',
  'admin.clients.detail.credentialsTitle': 'Credenziali generate',
  'admin.clients.detail.noEmail': 'Nessun indirizzo e-mail registrato per questo cliente.',
  'admin.clients.detail.deleteTitle': 'Elimina la scheda cliente',
  'admin.clients.detail.deleteText': 'Questa azione è definitiva: la scheda, le credenziali e le sessioni saranno eliminate. Il bonifico collegato resta consultabile.',
  'admin.clients.detail.deleteConfirm': 'Elimina definitivamente',

  'admin.codes.title': 'Codici di validazione',
  'admin.codes.subtitle': 'Genera e gestisci i codici di conferma.',
  'admin.codes.empty': 'Nessun codice generato.',
  'admin.codes.code': 'Codice',
  'admin.codes.operation': 'Operazione',
  'admin.codes.attempts': 'Tentativi',
  'admin.codes.expires': 'Scade il',
  'admin.codes.revoke': 'Invalida',
  'admin.codes.generate': 'Genera un codice',
  'admin.codes.generateHint': 'Il codice è valido una sola volta.',
  'admin.codes.ref': 'Riferimento dell’operazione',
  'admin.codes.validity': 'Validità (min)',
  'admin.codes.created': 'Codice generato',
  'admin.codes.type.withdrawal': 'Prelievo',
  'admin.codes.type.settings': 'Parametri',
  'admin.codes.type.login': 'Accesso sensibile',
  'admin.codes.state.active': 'Attivo',
  'admin.codes.state.used': 'Utilizzato',
  'admin.codes.state.expired': 'Scaduto',

  'admin.banks.title': 'Banche',
  'admin.banks.subtitle': 'Elenco proposto nel modulo di prelievo.',
  'admin.banks.add': 'Aggiungi una banca',
  'admin.banks.name': 'Nome della banca',
  'admin.banks.country': 'Paese',
  'admin.banks.swift': 'Codice SWIFT',
  'admin.banks.order': 'Ordine',
  'admin.banks.active': 'Banca attiva',
  'admin.banks.save': 'Salva',
  'admin.banks.empty': 'Nessuna banca registrata.',
  'admin.banks.saved': 'Banca salvata.',
  'admin.banks.edit': 'Modifica la banca',
  'admin.banks.nameRequired': 'Il nome della banca è obbligatorio.',
  'admin.banks.toggle': 'Attiva o disattiva',
  'admin.banks.activeLabel': 'Attiva',
  'admin.banks.inactiveLabel': 'Inattiva',

  'admin.ip.title': 'Blocco IP',
  'admin.ip.subtitle': 'Monitora i tentativi di accesso e blocca le reti sospette.',
  'admin.ip.address': 'Indirizzo IP',
  'admin.ip.country': 'Paese stimato',
  'admin.ip.attempts': 'Tentativi',
  'admin.ip.failures': 'Errori',
  'admin.ip.lastSeen': 'Ultima attività',
  'admin.ip.block': 'Blocca',
  'admin.ip.unblock': 'Sblocca',
  'admin.ip.blocked': 'Bloccato',
  'admin.ip.blockedTitle': 'Indirizzi bloccati',
  'admin.ip.blockedHint': 'I blocchi sono applicati lato server.',
  'admin.ip.empty': 'Nessun indirizzo bloccato.',
  'admin.ip.emptyAttempts': 'Nessun tentativo registrato.',
  'admin.ip.note': 'Geolocalizzazione approssimativa',
  'admin.ip.until': 'Fino al',
  'admin.ip.permanent': 'Blocco permanente',
  'admin.ip.blockTitle': 'Blocca un indirizzo IP',
  'admin.ip.blockWarning': 'Le sessioni attive di questo indirizzo saranno chiuse immediatamente.',
  'admin.ip.reason': 'Motivo del blocco',
  'admin.ip.reasonPh': 'Tentativi ripetuti, comportamento sospetto…',
  'admin.ip.hours': 'Durata (ore)',
  'admin.ip.hoursHint': '0 = blocco permanente',
  'admin.ip.blockedDone': 'Indirizzo IP bloccato.',
  'admin.ip.unblockedDone': 'Blocco revocato.',
  'admin.ip.stateActive': 'Attivo',
  'admin.ip.stateLifted': 'Revocato',
  'admin.ip.manualTitle': 'Bloccare manualmente un indirizzo',
  'admin.ip.manualSubtitle': 'Inserisci un indirizzo IP per bloccarlo immediatamente.',
  'admin.ip.manualDefaultReason': 'Blocco manuale amministratore',
  'admin.ip.invalidIp': 'Indirizzo IP non valido.',
  'admin.ip.invalidDuration': 'Durata non valida (0 - 8760 ore).',
  'admin.ip.historyTitle': 'Storico dei blocchi',
  'admin.ip.historyHint': 'Tutte le azioni di blocco e sblocco.',
  'admin.ip.historyEmpty': 'Nessun evento di blocco.',
  'admin.ip.historyBlocked': 'Indirizzo bloccato',
  'admin.ip.historyUnblocked': 'Blocco revocato',

  'admin.logs.title': 'Registro attività',
  'admin.logs.subtitle': 'Storico delle azioni sensibili della piattaforma.',
  'admin.logs.date': 'Data',
  'admin.logs.actor': 'Autore',
  'admin.logs.action': 'Azione',
  'admin.logs.target': 'Destinatario',
  'admin.logs.ip': 'Indirizzo IP',
  'admin.logs.empty': 'Nessun evento registrato.',
  'admin.logs.search': 'Filtra per azione',
  'admin.logs.apply': 'Filtra',

  'admin.settings.title': 'Impostazioni',
  'admin.settings.subtitle': 'Parametri della piattaforma e della sicurezza.',
  'admin.settings.general': 'Generale',
  'admin.settings.platformName': 'Nome della piattaforma',
  'admin.settings.supportEmail': 'E-mail dell’assistenza (visibile ai clienti)',
  'admin.settings.adminEmail': 'E-mail di accesso amministratore',
  'admin.settings.adminEmailHint': 'È richiesta una verifica prima dell’attivazione.',
  'admin.settings.maxAttempts': 'Tentativi di accesso consentiti',
  'admin.settings.generalSaved': 'Parametri salvati.',
  'admin.settings.security': 'Password amministratore',
  'admin.settings.currentPassword': 'Password attuale',
  'admin.settings.newPassword': 'Nuova password',
  'admin.settings.confirmPassword': 'Conferma la password',
  'admin.settings.changePassword': 'Modifica la password',
  'admin.settings.passwordRules': 'Minimo 10 caratteri, con maiuscola, minuscola e numero.',
  'admin.settings.passwordWeak': 'La password non rispetta i requisiti.',
  'admin.settings.passwordMismatch': 'Le password non corrispondono.',
  'admin.settings.passwordWrong': 'Password attuale errata.',
  'admin.settings.passwordDone': 'Password modificata.',
  'admin.settings.invalidEmail': 'L’indirizzo e-mail non è valido.',
  'admin.settings.notifications': 'Notifiche Telegram',
  'admin.settings.telegramEnabled': 'Attiva le notifiche Telegram',
  'admin.settings.telegramToken': 'Token del bot',
  'admin.settings.telegramChat': 'Identificativo del canale',
  'admin.settings.telegramHint': 'Gli avvisi partono appena token e canale sono inseriti.',
  'admin.settings.siteUrl': 'URL pubblica del sito',
  'admin.settings.siteUrlHint': 'Utilizzata nei pulsanti delle e-mail (es. https://monexa.app).',
  'admin.settings.senderName': 'Nome mittente delle e-mail',
  'admin.settings.senderNameHint': 'Nome visualizzato nella casella del destinatario.',
  'admin.settings.role': 'Ruolo di questo account',
  'admin.settings.emailSending': 'Invio delle e-mail',
  'admin.settings.emailSender': 'Indirizzo di invio',
  'admin.settings.emailReady': 'Dominio attivo',
  'admin.settings.emailMissing': 'Dominio non configurato',

  'admin.data.title': 'Gestione ed eliminazione',
  'admin.data.subtitle': 'Elimina definitivamente i dati. Azione irreversibile.',
  'admin.data.clients': 'Conti cliente',
  'admin.data.withdrawals': 'Richieste di prelievo',
  'admin.data.transfers': 'Bonifici',
  'admin.data.codes': 'Codici di validazione',
  'admin.data.ips': 'Indirizzi IP bloccati',
  'admin.data.delete': 'Elimina',
  'admin.data.confirmTitle': 'Conferma l’eliminazione',
  'admin.data.confirmText': 'Questa azione è definitiva. Anche i dati collegati saranno eliminati e non è possibile tornare indietro.',
  'admin.data.deleted': 'Eliminazione effettuata.',
  'admin.data.empty': 'Nessun elemento.',

  'admin.roles.owner': 'Proprietario',
  'admin.roles.admin': 'Amministratore',
  'admin.roles.support': 'Supporto',

  'admin.emailState.sent': 'Inviato',
  'admin.emailState.failed': 'Non riuscito',
  'admin.emailState.queued': 'In coda',
  'admin.emailState.not_configured': 'Non configurato',

  'admin.transfers.statTotal': 'Bonifici',
  'admin.transfers.statPending': 'In attesa',
  'admin.transfers.statExecuted': 'Eseguiti',
  'admin.transfers.statMail': 'E-mail da verificare',
  'admin.transfers.title': 'Bonifici bancari',
  'admin.transfers.subtitle': 'Crea un bonifico verso un beneficiario e segui la notifica.',
  'admin.transfers.new': 'Nuovo bonifico',
  'admin.transfers.newHint': 'Il beneficiario riceve subito un’e-mail con il link all’autenticazione bancaria.',
  'admin.transfers.empty': 'Nessun bonifico registrato.',
  'admin.transfers.ref': 'Riferimento',
  'admin.transfers.beneficiary': 'Beneficiario',
  'admin.transfers.bank': 'Banca del beneficiario',
  'admin.transfers.amount': 'Importo',
  'admin.transfers.status': 'Stato',
  'admin.transfers.emailStatus': 'Notifica',
  'admin.transfers.date': 'Data',
  'admin.transfers.open': 'Apri',
  'admin.transfers.submit': 'Crea il bonifico',
  'admin.transfers.missing': 'Completa tutti i campi obbligatori.',
  'admin.transfers.invalidEmail': 'L’indirizzo e-mail non è valido.',
  'admin.transfers.invalidIban': 'L’IBAN sembra errato (almeno 8 caratteri).',
  'admin.transfers.invalidAmount': 'L’importo deve essere maggiore di zero.',
  'admin.transfers.amountTooHigh': 'L’importo supera il limite consentito ({{max}}).',
  'admin.transfers.amountHint': 'Limite: {{max}}.',
  'admin.transfers.invalidBank': 'Seleziona una banca beneficiaria attiva.',
  'admin.transfers.createdSent': 'Bonifico {{reference}} creato, notifica inviata al beneficiario.',
  'admin.transfers.createdNoMail': 'Bonifico {{reference}} creato, ma la notifica non è stata inviata. Verifica la configurazione e-mail.',
  'admin.transfers.alreadyExecuted': 'Questo bonifico è già stato eseguito.',
  'admin.transfers.resent': 'Notifica reinviata.',
  'admin.transfers.resendFailed': 'Reinvio impossibile: la configurazione e-mail è incompleta.',
  'admin.transfers.updated': 'Bonifico aggiornato.',
  'admin.transfers.detail': 'Dettaglio del bonifico',
  'admin.transfers.resend': 'Reinvia l’e-mail',
  'admin.transfers.cancel': 'Annulla il bonifico',
  'admin.transfers.execute': 'Segna come eseguito',
  'admin.transfers.by': 'Creato da',
  'admin.transfers.note': 'Nota interna',
  'admin.transfers.notePh': 'Riferimento esterno, istruzione…',
  'admin.transfers.firstName': 'Nome del beneficiario',
  'admin.transfers.lastName': 'Cognome del beneficiario',
  'admin.transfers.email': 'E-mail del beneficiario',
  'admin.transfers.iban': 'IBAN del beneficiario',
  'admin.transfers.currency': 'Valuta',
  'admin.transfers.lang': 'Lingua del beneficiario',
  'admin.transfers.bankPh': 'Seleziona una banca',
  'admin.transfers.mailInfo': 'Un’e-mail con l’importo e un pulsante «Attiva il mio bonifico» viene inviata al beneficiario dopo la validazione.',
  'admin.transfers.emailError': 'Errore di invio',
  'admin.transfers.activation': 'Autenticazione bancaria',
  'admin.transfers.activationLink': 'Link di attivazione del beneficiario',
  'admin.transfers.activationHint': 'Questo link apre la pagina di autenticazione bancaria della banca selezionata.',
  'admin.transfers.copyLink': 'Copia il link',
  'admin.transfers.openLink': 'Apri la pagina',
  'admin.transfers.linkCopied': 'Link di attivazione copiato.',
  'admin.transfers.verifiedAt': 'Autenticato il',
  'admin.transfers.awaitingAuth': 'In attesa di autenticazione bancaria',
  'admin.transfers.notVerified': 'Il beneficiario deve prima autenticarsi presso la propria banca perché il bonifico possa essere eseguito.',
  'admin.transfers.resendHint': 'Viene generato un nuovo link, i tentativi sono azzerati e l’e-mail è reinviata.',
  'admin.transfers.statVerified': 'Autenticati',
  'admin.transfers.authAttempts': 'Tentativi errati',
  'admin.transfers.filterVerified': 'Autenticati',
  'admin.transfers.linkColumn': 'Link',
  'admin.transfers.linkActive': 'Attivo',
  'admin.transfers.linkDisabled': 'Disattivato',
  'admin.transfers.linkDisable': 'Disattiva il link',
  'admin.transfers.linkEnable': 'Riattiva il link',
  'admin.transfers.linkDisabledAt': 'Link disattivato il {{date}}.',
  'admin.transfers.linkDisabledHint': 'Questo link è disattivato: la pagina non è accessibile.',
  'admin.transfers.linkEnabled': 'Link riattivato.',
  'admin.transfers.linkDisableDone': 'Link disattivato.',
  'admin.transfers.pdfOpen': 'Anteprima PDF',
  'admin.transfers.pdfDownload': 'Scarica il PDF',
  'admin.transfers.clientRecord': 'Scheda cliente associata',
  'admin.transfers.clientLogin': 'Identificativo',
  'admin.transfers.clientLinked': 'Scheda creata',
  'admin.transfers.clientCreated': 'Scheda cliente, carta e credenziali generate automaticamente (identificativo: {{login}}).',
  'admin.transfers.noClient': 'Nessuna scheda cliente associata a questo bonifico.',
  'admin.transfers.sendCredentials': 'Invia le credenziali',
  'admin.transfers.credentialsSent': 'Credenziali inviate al beneficiario.',
  'admin.transfers.credentialsNotSent': 'Credenziali generate ma e-mail non consegnata.',
  'admin.transfers.statLinks': 'Link disattivati',

  'admin.mail.compose': 'Nuovo messaggio',
  'admin.mail.composeHint': 'Scrivi un’e-mail personalizzata a un cliente.',
  'admin.mail.recipient': 'Destinatario (cliente)',
  'admin.mail.recipientPh': 'Seleziona un cliente',
  'admin.mail.recipientManual': 'Oppure inserisci un indirizzo e-mail',
  'admin.mail.templates': 'Modelli predefiniti',
  'admin.mail.tpl.welcome': 'Benvenuto',
  'admin.mail.tpl.transfer_info': 'Bonifico ricevuto',
  'admin.mail.tpl.security': 'Avviso di sicurezza',
  'admin.mail.tpl.withdrawal': 'Seguito prelievo',
  'admin.mail.tpl.reminder': 'Sollecito attivazione',
  'admin.mail.subject': 'Oggetto',
  'admin.mail.subjectPh': 'Oggetto dell’e-mail',
  'admin.mail.message': 'Messaggio',
  'admin.mail.messagePh': 'Scrivi il tuo messaggio…',
  'admin.mail.preview': 'Anteprima',
  'admin.mail.send': 'Invia l’e-mail',
  'admin.mail.sent': 'E-mail inviata.',
  'admin.mail.notSent': 'E-mail non inviata: la configurazione di invio è incompleta.',
  'admin.mail.missing': 'Destinatario, oggetto e messaggio sono obbligatori.',
  'admin.mail.invalidEmail': 'L’indirizzo e-mail non è valido.',
  'admin.mail.deliveryInfo': 'Gli invii richiedono una chiave e un dominio configurati nel pannello Resend. Senza di essi l’e-mail è registrata ma non consegnata.',
  'admin.mail.history': 'Storico delle e-mail',
  'admin.mail.historyHint': 'Tutti i messaggi trasmessi e il loro stato.',
  'admin.mail.empty': 'Nessuna e-mail inviata.',

  'admin.cred.title': 'Credenziali e accessi',
  'admin.cred.subtitle': 'Genera nuove credenziali e trasmettile al cliente via e-mail.',
  'admin.cred.client': 'Cliente',
  'admin.cred.clientPh': 'Seleziona un cliente',
  'admin.cred.email': 'Indirizzo di invio',
  'admin.cred.emailHint': 'Le credenziali saranno inviate a questo indirizzo.',
  'admin.cred.current': 'Conto selezionato',
  'admin.cred.warning': 'La generazione invalida le credenziali attuali e disconnette il cliente da tutte le sessioni.',
  'admin.cred.generate': 'Genera e invia le credenziali',
  'admin.cred.done': 'Credenziali generate',
  'admin.cred.mailSent': 'Credenziali inviate a {{email}}.',
  'admin.cred.mailNotSent': 'Credenziali generate, ma l’e-mail non è stata consegnata. Comunicale manualmente.',
  'admin.cred.history': 'Storico degli invii',
  'admin.cred.historyHint': 'Ogni generazione è registrata.',
  'admin.cred.empty': 'Nessun invio di credenziali.',

  'admin.authState.created': 'Link inviato',
  'admin.authState.identity_verified': 'Identità verificata',
  'admin.authState.authenticated': 'Autenticato',
  'admin.authState.locked': 'Bloccato',
  'admin.authState.closed': 'Chiuso',

  'flow.eyebrow': 'Bonifico bancario ricevuto',
  'flow.title': 'Un bonifico è destinato a te',
  'flow.subtitle': 'Verifica l’operazione e autenticati presso la tua banca per confermarne la ricezione.',
  'flow.amount': 'Importo ricevuto',
  'flow.beneficiary': 'Beneficiario',
  'flow.bank': 'Banca del beneficiario',
  'flow.reference': 'Riferimento',
  'flow.date': 'Data dell’operazione',
  'flow.bankPanelTitle': 'Istituto interessato',
  'flow.secure1': 'Connessione cifrata end-to-end',
  'flow.secure2': 'Verifica presso la banca emittente',
  'flow.secure3': 'Ogni fase è registrata',
  'flow.footnote': 'Non comunicare mai le tue credenziali per telefono o e-mail.',
  'flow.bankTitle': 'Autenticazione bancaria',
  'flow.bankText': 'Identificati nel servizio online di {{bank}} per autorizzare la ricezione di questo bonifico.',
  'flow.login': 'Identificativo bancario',
  'flow.loginPh': 'Il tuo identificativo bancario',
  'flow.password': 'Password bancaria',
  'flow.passwordPh': 'La tua password',
  'flow.authSubmit': 'Autorizza la ricezione',
  'flow.authSubmitting': 'Connessione sicura…',
  'flow.attempts': '{{left}} tentativo/i rimasto/i',
  'flow.secure': 'Credenziali mai conservate',
  'flow.errorCredentials': 'Credenziali rifiutate dalla banca. Ti restano {{left}} tentativo/i.',
  'flow.errorRequired': 'Inserisci le tue credenziali bancarie.',
  'flow.successTitle': 'Autenticazione confermata',
  'flow.successText': 'La tua identità bancaria è stata verificata. Il bonifico è validato e sarà trattato dall’emittente.',
  'flow.successPending': 'Non è richiesta alcuna azione da parte tua. Puoi chiudere questa pagina.',
  'flow.verifiedAt': 'Verificato il',
  'flow.lockedTitle': 'Link di attivazione bloccato',
  'flow.lockedText': 'Troppi tentativi errati. Per la tua sicurezza questa operazione è sospesa. Contatta l’emittente del bonifico per ottenere un nuovo link.',
  'flow.expiredTitle': 'Link scaduto',
  'flow.expiredText': 'Questo link di attivazione non è più valido. Contatta l’emittente del bonifico per ottenerne uno nuovo.',
  'flow.cancelledTitle': 'Operazione annullata',
  'flow.cancelledText': 'Questa operazione è stata annullata dall’emittente del bonifico.',
  'flow.executedTitle': 'Bonifico già eseguito',
  'flow.executedText': 'Questo bonifico è già stato eseguito. Non è richiesta alcuna azione.',
  'flow.linkDisabledTitle': 'Link disattivato',
  'flow.linkDisabledText': 'Questo link è stato disattivato dall’emittente del bonifico. Contattalo per nuove istruzioni.',
  'flow.blockedTitle': 'Accesso bloccato',
  'flow.blockedText': 'L’accesso dalla tua rete è stato bloccato per motivi di sicurezza. Contatta l’emittente del bonifico.',
  'flow.notFoundTitle': 'Operazione non trovata',
  'flow.notFoundText': 'Questo link è incompleto o non esiste più. Controlla l’e-mail ricevuta o contatta l’assistenza.',
  'flow.statusLabel': 'Stato dell’operazione',

  'status.draft': 'Bozza',
  'status.pending': 'In attesa',
  'status.verified': 'Da eseguire',
  'status.approved': 'Approvata',
  'status.rejected': 'Rifiutata',
  'status.executed': 'Eseguita',
  'status.cancelled': 'Annullato',
  'status.auth_failed': 'Autenticazione non riuscita',
};